import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles()((theme) => ({
  box: {
    ...dFlex(),
    padding: 8,
    flexDirection: 'column',
    background: theme.secondary.s1,
    borderRadius: theme.borderRadius.md,
  },
}));

export default useStyles;
